























































import Vue from 'vue';
import * as compagniaAssicurativaApi from '../services/compagnia-assicurativa-api';
import {
    CompagniaAssicurativaList,
    CompagniaAssicurativaListViewModel,
} from '../types';

export default Vue.extend({
    data(): CompagniaAssicurativaListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.compagnia-assicurativa'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await compagniaAssicurativaApi.getList();
        },
        showDetail(item: CompagniaAssicurativaList) {
            this.$router.push({
                name: 'CompagniaAssicurativaDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await compagniaAssicurativaApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
